import { render, staticRenderFns } from "./MagazineRecipients.vue?vue&type=template&id=3122cc4f&"
import script from "./MagazineRecipients.vue?vue&type=script&lang=js&"
export * from "./MagazineRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports